import prospectDomain from './prospect.domain';

export const domain = prospectDomain;
